export function getQueryFromURLSearchParams(searchParams: URLSearchParams): {
  [key: string]: string[];
} {
  const query: { [key: string]: string[] } = {};

  for (const key of searchParams.keys()) {
    query[key] = searchParams.getAll(key);
  }

  return query;
}
